import { render, staticRenderFns } from "./ShowMix.vue?vue&type=template&id=3091616d&scoped=true&"
import script from "./ShowMix.vue?vue&type=script&lang=js&"
export * from "./ShowMix.vue?vue&type=script&lang=js&"
import style0 from "./ShowMix.vue?vue&type=style&index=0&id=3091616d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3091616d",
  null
  
)

export default component.exports